import React from "react";

import { Divider } from "@mui/material";

import { SettingsModuleProps } from "@app/analytics/account/types";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";
import {
  EnterpriseWorkspaceSettings,
  EnterpriseWorkspaceSettingUpdateConfig,
} from "@app/common/workspaces/types";

import SliderHeading from "../components/SliderHeading";
import WorkspacePermissionItem from "../components/WorkspacePermissionItem";

const MEETING_REPORT_OPTIONS: {
  title: string;
  name: keyof EnterpriseWorkspaceSettings;
  subtitle: string;
  recommendation?: { value: string; description: string };
}[] = [
  {
    title: "Transcripts",
    name: "transcripts",
    subtitle: "Can view transcripts in their Meeting Reports",
  },
  {
    title: "Audio & Video Playback",
    name: "storeRecording",
    subtitle: "Can view meeting playback in their Meeting Reports",
  },
  {
    title: "Team Report Access",
    name: "shareTeamData",
    subtitle: "Can view meeting reports for anyone in their team(s)",
    recommendation: {
      value: "Admin",
      description: "Gives only admins the ability to see everyone's reports",
    },
  },
];

const MeetingReportsModule = ({
  onSettingUpdate,
  settings,
  workspaceIsInactive,
}: SettingsModuleProps) => {
  return (
    <WorkspaceSettingsAccordion
      title="Meeting Report Access"
      subtitle="Customize what Workspace members can access within Meeting Reports and how they are shared"
      sx={{
        borderTop: "1px solid",
        borderRadius: 0,
        borderColor: "shades.neutral.100",
      }}
    >
      <SliderHeading />
      {MEETING_REPORT_OPTIONS.map((option, i) => {
        const settingForOption = settings[
          option.name
        ] as EnterpriseWorkspaceSettingUpdateConfig;

        return (
          <React.Fragment key={option.name}>
            {i > 0 && <Divider />}
            <WorkspacePermissionItem
              disabled={workspaceIsInactive}
              {...option}
              onSettingUpdate={onSettingUpdate}
              setting={settingForOption}
            />
          </React.Fragment>
        );
      })}
    </WorkspaceSettingsAccordion>
  );
};

export default MeetingReportsModule;
